import React from 'react';
import { RightRow, ButtonBlock, Row1, TeamMember } from './styles';
import Avatar from '../../avatar';
import isEmpty from 'lodash/isEmpty';
import { Box, LeftRow, Row, Subtitle, Title } from '../styles';
import { rootStore } from '../../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import Tooltip from '../../tooltip';
import IconButton from '../../button/iconButton';
import { AVATAR_BORDER, ICON_BUTTON_SIZE, ICON_BUTTON_TYPE } from '../../../global/constants';

interface Props {
  setMainModel: (value: boolean) => void;
  OpenDeleteMemberModel: (id: string) => void;
  isTemplateProject?: boolean;
}

const TeamsSettingCard: React.FC<Props> = (props) => {
  const { setMainModel, OpenDeleteMemberModel, isTemplateProject } = props;

  //Mobx store variables
  const { projectStore, projectTemplateStore } = rootStore;
  const { currentProject: projectDetails } = projectStore;
  const { currentProjectTemplate } = projectTemplateStore;
  const currentProject = isTemplateProject ? currentProjectTemplate : projectDetails;

  return (
    <Box>
      <Row>
        <LeftRow>
          <Title>Team</Title>
          <Subtitle>Manage who is member of this project</Subtitle>
        </LeftRow>
        <RightRow role='button' onClick={() => setMainModel(true)}>
          <p>Manage</p>
        </RightRow>
      </Row>
      <Row1>
        {currentProject?.users &&
          currentProject?.users?.map((item) => {
            return (
              !isEmpty(item?.id) && (
                <ButtonBlock key={item?.id}>
                  <TeamMember>
                    <Avatar
                      imgSrc={item?.profile_photo || ''}
                      name={item?.name ? item?.name : 'U N'}
                      size={24}
                      borderVariant={AVATAR_BORDER.NONE}
                    />
                    <p>{item?.name}</p>
                  </TeamMember>
                  <Tooltip title='Remove user from project' placement='bottom' maxWidth={'max-content'}>
                    <IconButton
                      iconName='new-close-icon'
                      size={ICON_BUTTON_SIZE.EXTRA_SMALL}
                      variant={ICON_BUTTON_TYPE.TERTIARY}
                      className='closeIcon'
                      onClick={() => OpenDeleteMemberModel(item?.id)}
                      type='rounded'
                    />
                  </Tooltip>
                </ButtonBlock>
              )
            );
          })}
      </Row1>
    </Box>
  );
};

export default observer(TeamsSettingCard);
